import apiRequest from './apiRequest';

export type RenderCanvasResponse = {
  key: string;
  url: string;
};

export type PostRenderCanvasPayload = {
  prompt: string;
};

export default async function postRenderCanvas(
  projectID: string,
  body: PostRenderCanvasPayload,
) {
  return await apiRequest<RenderCanvasResponse>(
    'mogen-orchestration',
    `/v2/projects/${projectID}/renderCanvas`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}
